"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const styles_1 = require("@material-ui/core/styles");
const classnames_1 = __importDefault(require("classnames"));
const prop_types_1 = __importDefault(require("prop-types"));
const button_1 = __importDefault(require("../material-button/button"));
require("../../styles/components/add-item-button.less");
const StyledButton = (0, styles_1.withStyles)({
    root: {
        textTransform: 'none',
        color: '#5dacd2',
        textDecoration: 'none',
        '&:hover': {
            backgroundColor: 'transparent',
            textDecoration: 'underline',
        },
    },
})(button_1.default);
const AddItemButton = ({ onClick, text, disabled, className, variant, size }) => (react_1.default.createElement(StyledButton, { className: (0, classnames_1.default)(className, 'add-item-button'), variant: "text", size: size, onClick: onClick, disabled: disabled, textVariant: variant, disableRipple: true },
    react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("i", { className: "fa fa-plus-circle" }),
        text)));
AddItemButton.defaultProps = {
    text: 'Add',
    size: 'small',
    disabled: false,
    className: '',
    variant: 'caption',
};
AddItemButton.propTypes = {
    onClick: prop_types_1.default.func.isRequired,
    text: prop_types_1.default.string,
    size: prop_types_1.default.string,
    disabled: prop_types_1.default.bool,
    className: prop_types_1.default.string,
    variant: prop_types_1.default.oneOf([
        'h1',
        'h2',
        'h3',
        'h4',
        'h5',
        'subtitle1',
        'subtitle2',
        'body1',
        'body2',
        'caption',
        'overline',
        'inherit',
    ]),
};
exports.default = AddItemButton;
//# sourceMappingURL=add-item-button.js.map